import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#0a0a09] text-[#f5f2ea]">
      <Nav />
      <main className="pt-[57px]">{children}</main>
      <Footer />
    </div>
  );
}
